<template>
  <div class="main-body" :style='"height:"+(th+115)+"px"'>
<!--    <div class="header">岗位管理</div>-->
    <div class="out">

      <div class="search2">
        <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right;">
          <el-select v-model="departmentId" clearable placeholder="请选择科室" style="margin-right: 5px">
            <el-option
                v-for="item in department_arr"
                :key="item.id"
                :label="item.departmentClassName+'/'+item.name"
                :value="item.id">
            </el-option>
          </el-select>
          <el-input size="mini" placeholder="请输入岗位名称" v-model="name" maxlength="11" clearable style="width:200px;margin-right:5px"></el-input>
          <el-button size="mini" type="primary" plain icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border>
        <el-table-column prop="departmentClassName" label="科室分类" width="200"></el-table-column>
        <el-table-column prop="departmentName" label="科室" width="200"></el-table-column>
        <el-table-column prop="name" label="岗位名称" width="200"></el-table-column>

        <el-table-column prop="status" label="考核名称" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.checkNameJobClassRelDTO != null">
              {{scope.row.checkNameJobClassRelDTO.checkNameName}}
            </span>
          </template>
        </el-table-column>


        <el-table-column prop="sort" label="排序"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>

            <el-button v-if="scope.row.checkNameJobClassRelDTO == null" size="mini" @click="handleEditCheckName(scope.$index, scope.row)">考核名称</el-button>
            <el-button v-else size="mini" @click="handleDeleteCheckName(scope.$index, scope.row)">删除考核名称</el-button>

          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
    <EditCheckName ref="myEditCheckName" v-show="showModalEditCheckName" v-on:closeMe="showModalEditCheckName=false" v-on:getList="getList"></EditCheckName>

  </div>
</template>

<script>

import Add from "./Add";
import Edit from "./Edit";
import EditCheckName from "./EditCheckName";

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",


  activated() {

    let topTabs = this.$store.state.topTabs;
    if(topTabs && topTabs.length>0){
      let path = this.$route.path;
      let index = topTabs.findIndex(item => item === path);
      if(index ==-1){
        this.init();
      }
    }
    else{
      this.init();
    }


    let topTabs1 = this.$store.state.topTabs;
    if(topTabs1 == null){
      topTabs1 = [];
      topTabs1.push(this.$route.path);
      this.$store.commit('update', ['topTabs',topTabs1]);
    }
    else{
      let index = topTabs.findIndex(item => item === this.$route.path);
      if(index ==-1){
        topTabs1.push(this.$route.path);
        this.$store.commit('update', ['topTabs',topTabs1]);
      }
    }


  },
  deactivated() {
    //console.log("JobClass停用");
  },
  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{

      name:'',

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      showModalAdd:false,
      showModalEdit:false,
      showModalEditCheckName:false,

      th:0,

      departmentId:'',
      department_arr:[],

    }
  },
  created(){
    this.th = this.$store.state.tableHeight;
  },
  components:{
    Add,Edit,EditCheckName
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    init(){
      this.getDepartment();
      this.getList();
    },

    getDepartment(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Department/AdmList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }

      }).then( (response)=> {
        if(response.data.error == 0){
          this.department_arr = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    handleEditCheckName(index, row) {
      this.$refs.myEditCheckName.init(row);
      this.showModalEditCheckName = !this.showModalEditCheckName;
    },
    handleDeleteCheckName(index, row){
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "CheckNameJobClassRel/AdmDelete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            checkNameJobClassRelId:row.checkNameJobClassRelDTO.id,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList();
            this.$message({type: 'success', message: '删除成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
      });
    },



    search(){
      this.currentPage = 1;
      this.getList();
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'JobClass/AdmPage',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          departmentId:this.departmentId,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },



  }
}
</script>

